const Menu = [
  { label: 'Servicios', path: '/landing#services', external: false },
  { label: 'Módulo de Atención Externa', path: '/appointment#init', external: false },
  { label: 'Empresas', path: '/appointment#company', external: false },
  { label: 'Laboratorios Asociados', path: '/appointment#labs', external: false },
  { label: 'Formulario epidemiológico', path: 'https://www.laboratoriosiml.com/registro/', external: true },
  { label: 'Preguntas frecuentes', path: '/appointment#faqs', external: false },
  { label: 'IML', path: 'https://www.laboratoriosiml.com/index.php', external: true }
]

export default Menu
